'use client';
import React from 'react';
import Icon from '@/components/ui/AppIcon';
import type { ForgeArenaData } from '@/lib/services/forgeArenaService';

interface ChampionBannerProps {
  arenaData: ForgeArenaData | null;
  loading: boolean;
}

export default function ChampionBanner({ arenaData, loading }: ChampionBannerProps) {
  const todayChampion = !arenaData
    ? null
    : arenaData.todayScores.theo >= arenaData.todayScores.tracy
    ? { name: 'THEO', score: arenaData.todayScores.theo, color: 'var(--theo-color)', bg: 'score-green border' }
    : { name: 'TRACY', score: arenaData.todayScores.tracy, color: 'var(--tracy-color)', bg: 'score-amber border' };

  const weekChampion = !arenaData
    ? null
    : arenaData.weekScores.theo >= arenaData.weekScores.tracy
    ? { name: 'THEO', score: arenaData.weekScores.theo, color: 'var(--theo-color)', bg: 'score-green border' }
    : { name: 'TRACY', score: arenaData.weekScores.tracy, color: 'var(--tracy-color)', bg: 'score-amber border' };

  const monthChampion = !arenaData
    ? null
    : arenaData.monthScores.theo >= arenaData.monthScores.tracy
    ? { name: 'THEO', score: arenaData.monthScores.theo, color: 'var(--theo-color)', bg: 'score-green border' }
    : { name: 'TRACY', score: arenaData.monthScores.tracy, color: 'var(--tracy-color)', bg: 'score-amber border' };

  const items = [
    { period: 'TODAY', champion: todayChampion },
    { period: 'THIS WEEK', champion: weekChampion },
    { period: 'THIS MONTH', champion: monthChampion },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      {items.map((item) => (
        <div key={`champ-${item.period}`} className={`${item.champion?.bg ?? 'card-forge border'} rounded-xl p-5 text-center`}>
          <div className="text-forge-label mb-2">{item.period}&apos;S CHAMPION</div>
          {loading ? (
            <div className="animate-pulse space-y-2">
              <div className="h-6 w-16 bg-muted rounded mx-auto" />
              <div className="h-8 w-12 bg-muted rounded mx-auto" />
            </div>
          ) : (
            <>
              <Icon name="TrophyIcon" size={24} className="mx-auto mb-2" style={{ color: item.champion?.color ?? 'var(--muted-foreground)' }} />
              <div className="text-2xl font-black tracking-widest" style={{ color: item.champion?.color ?? 'var(--muted-foreground)' }}>
                {item.champion?.name ?? '—'}
              </div>
              <div className="font-tabular font-black text-3xl text-foreground mt-1">{item.champion?.score ?? 0}</div>
              <div className="text-forge-label">Forge Score</div>
            </>
          )}
        </div>
      ))}
    </div>
  );
}